import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ProviderUsuario } from './provider/usuario.provider';
import { ProviderCidades } from './provider/cidades.provider';
import { ProviderFirebase } from './provider/firebase.provider';
import { ProviderPosicoes } from './provider/posicoes.provider';
import { LogoutModal, Mensagens, PoliticaDeProvacidadeInicial } from './components/modals';
import Login from './viwers/login';
import Cadastro from './viwers/cadastro';
import { toastContainer as ToastContainer } from './functions/notifications';
import NotFound from './viwers/notFound';
import Home from './viwers/dashboard';
import Confirmacao from './viwers/cadastro/confirmar';
import LandingPage from './viwers/landingPage';
import Coleta from './viwers/coleta/home';
import NewSale from './viwers/coleta/newSale';
import Authentication from './viwers/coleta/authentication';

function App() {
  const [termosAceitos, setTermosAceitos] = useState('ocultar');

  useEffect(() => {
    const showPoliticas = !!localStorage.getItem('politicas');
    if (!showPoliticas) {
      setTermosAceitos('show');
    }
  }, []);

  return (
    <>
      <ProviderUsuario>
        <ProviderCidades>
          <ProviderFirebase>
            <ProviderPosicoes>
              {/* Inicio Componenetes que rodam em qualquer tela */}
              <>
                <LogoutModal />
                <Mensagens />
                <ToastContainer />
                <PoliticaDeProvacidadeInicial aceite={{ show: false }} />
              </>
              {/* Fim Componenetes que rodam em qualquer tela */}
              <div className={`${termosAceitos}-cookies-politica`}>
                <span>
                  Nós utilizamos cookies para memorizar suas preferências e elaborar estatísticas
                  sobre o uso de nosso serviço e melhorar a experiência do usuário.
                  Ao continuar navegando você declara estar ciente dessas condições
                  descritas em nossa
                  {' '}
                  <a href="#politicas" data-toggle="modal" data-target="#modal-politica-de-privacidade-i">Política de Privacidade.</a>
                </span>
                <button
                  onClick={() => {
                    localStorage.setItem('politicas', true);
                    setTermosAceitos('hide');
                  }}
                  type="button"
                  className="button-termos"
                >
                  OK ENTENDI
                </button>
              </div>
              <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/newsale" component={NewSale} />
                <Route exact path="/coleta" component={Coleta} />
                <Route exact path="/cadastro" component={Cadastro} />
                <Route exact path="/cadastro/confirmacao" component={Confirmacao} />
                <Route exact path="/dashboard" component={Home} />
                <Route exact path="/authentication/:id/key=:uid" component={Authentication} />
                <Route path="*" component={NotFound} />
              </Switch>
            </ProviderPosicoes>
          </ProviderFirebase>
        </ProviderCidades>
      </ProviderUsuario>
    </>
  );
}

export default App;
